import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { UserService } from '../../../services/user.service';
import { DataFhirAdapter, DataFhirModel } from '../../data.model';
import { DictionariesCollectionService } from '../../dictionaries/dictionaries-collection.service';

export type QuestionnaireResponseEntry =
  DataFhirModel<fhir4.QuestionnaireResponse> & fhir4.QuestionnaireResponse;

@Injectable({
  providedIn: 'root',
})
export class QuestionnaireResponseEntryAdapter extends DataFhirAdapter<QuestionnaireResponseEntry> {
  constructor(
    protected dictionariesCollection: DictionariesCollectionService,
    protected userService: UserService,
  ) {
    super('QuestionnaireResponse', dictionariesCollection);
  }

  protected blankResource(): any {}

  fromResource$(observation): Observable<QuestionnaireResponseEntry> {
    return super.fromResource$(observation).pipe(
      map((baseItem) => {
        return {
          ...observation,
          ...baseItem,
        };
      }),
    );
  }

  toResource(
    questionnaireResponse: QuestionnaireResponseEntry,
  ): fhir4.QuestionnaireResponse {
    const baseResource = super.toResource(questionnaireResponse);

    const newQuestionnaireResponse: fhir4.QuestionnaireResponse = {
      ...baseResource,
      basedOn: questionnaireResponse.basedOn,
      subject: questionnaireResponse.subject,
    };

    return newQuestionnaireResponse;
  }
}
